<template>
    <div class="headline-wrapper">
        <h2><span>{{ text }}</span></h2>
    </div>
</template>

<script>
export default {
    props: ["text"]
}
</script>

<style lang="scss" scoped>
@import "../scss/_variables";

.headline-wrapper {
    border-bottom: 1px solid;
    border-color: $c-collection-nav-border;
    height: 25px;
    margin: 90px 0 115px;
    text-align: center;

    h2 {
        margin-right: -0.5em;
    }
}

h2 {
    span {
        background-color: $c-section-bg;
        display: inline-block;
        padding: 0 5em 0 4.7em;

        @media screen and (max-width: $screen-laptop) {
            padding: 0 3em 0 2.7em;
        }

        @media screen and (max-width: $screen-tablet) {
            padding: 0 1.5em 0 1.2em;
        }

        @media screen and (max-width: $screen-mobile) {
            padding: 0 .5em 0 .2em;
        }
    }
}
</style>
